import { render, staticRenderFns } from "./ProdutoFamiliaModal.vue?vue&type=template&id=4a5116c9&scoped=true"
import script from "./ProdutoFamiliaModal.vue?vue&type=script&lang=js"
export * from "./ProdutoFamiliaModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutoFamiliaModal.vue?vue&type=style&index=0&id=4a5116c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5116c9",
  null
  
)

export default component.exports